import axios from 'axios';

const EXTRACTION_API_BASE = process.env.EXTRACTION_API_BASE_URL || 'http://172.16.16.111:8016';
const API_BASE = process.env.REACT_APP_API_BASE_URL || 'http://172.16.16.111:8016';

export const getExtract = async (files) => {
    try {
        const formData = new FormData();
        
        if (files) {
            if (Array.isArray(files)) {
                files.forEach((file) => {
                    formData.append('file', file);
                });
            } else {
                formData.append('file', files);
            }
        }

        const response = await axios.post(
            `${EXTRACTION_API_BASE}/api/upload/file`,
            formData,
            {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            }
        );
        console.log("Extraction Data Response:", response.data);
        return response.data;
    } catch (error) {
        console.error("Error fetching extraction data:", error.response?.data || error.message);
        return { error: error.response?.data?.error || error.message };
    }
};


export const register = async ({ fullName, email, password }) => {
    try {
        const resp = await axios.post(`${API_BASE}/api/auth/register`, {
            fullName,
            email,
            password,
        });
        return resp.data;
    } catch (err) {
        // normalize error
        const data = err.response?.data || err;
        throw data;
    }
};

export const login = async ({ email, password }) => {
    try {
        const resp = await axios.post(`${API_BASE}/api/auth/login`, {
            email,
            password,
        });
        return resp.data;
    } catch (err) {
        const data = err.response?.data || err;
        throw data;
    }
};

export const getSchemes = async (query, sessionId, userLang = "en", model = "sarvam") => {
    try {
        const response = await axios.post(`${API_BASE}/api/scheme`, {
            query,
            session_id: sessionId,
            user_lang: userLang,
            model,
        });
        const data = response.data || {};
        let answerText = data.answer || data.english_answer || "";
        answerText = answerText.replace(/^answer\s*:\s*/i, "");

        return {
            original_question: data.original_question || query,
            answer:            answerText,
            intent:            data.intent || "odisha_scheme",
            retrieved_answers: data.retrieved_answers || [],
            translated_answer: data.translated_answer,
            audio_base64:      data.audio_base64,
            language:          data.language,
            ask:               data.ask,
            session_ended:     data.session_ended,
        };
    } catch (error) {
        console.error("Error fetching schemes:", error.response?.data || error.message);
        return { error: error.response?.data?.detail || error.response?.data?.error || error.message };
    }
};

export const uploadToQdrant = async ({ filename, collection_name, structured_data, force_push_existing = false, create_if_missing = true }) => {
    try {
        const response = await axios.post(`${EXTRACTION_API_BASE}/api/upload/qdrant`, {
            filename,
            collection_name,
            structured_data,
            force_push_existing,
            create_if_missing,
        });
        return response.data;
    } catch (error) {
        console.error("Error uploading to Qdrant:", error.response?.data || error.message);
        if (error.response?.status === 409) {
            return { error: error.response?.data?.detail || "Collection already exists", status: 409, collection_name };
        }
        return { error: error.response?.data?.error || error.message, status: error.response?.status };
    }
};
